export default function Services() {
  const services = [
    {
      icon: 'ri-tools-fill',
      title: 'Installazione Climatizzatori',
      description: 'Installazione professionale di climatizzatori di ogni marca e modello con garanzia completa',
      image: 'https://readdy.ai/api/search-image?query=professional%20technician%20installing%20modern%20white%20split%20air%20conditioner%20unit%20on%20interior%20wall%20wearing%20uniform%20using%20tools%20clean%20residential%20installation%20service%20high%20quality%20detailed%20work&width=600&height=400&seq=service-install-001&orientation=landscape',
      link: '#'
    },
    {
      icon: 'ri-settings-3-fill',
      title: 'Riparazione Climatizzatori',
      description: 'Riparazione rapida ed efficace di guasti e malfunzionamenti con ricambi originali',
      image: 'https://readdy.ai/api/search-image?query=skilled%20technician%20repairing%20air%20conditioning%20unit%20with%20professional%20tools%20and%20equipment%20wearing%20work%20uniform%20diagnostic%20maintenance%20service%20indoor%20residential%20setting%20detailed%20repair%20work&width=600&height=400&seq=service-repair-001&orientation=landscape',
      link: '#'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Manutenzione e Pulizia',
      description: 'Manutenzione periodica e pulizia approfondita per prestazioni ottimali e aria pulita',
      image: 'https://readdy.ai/api/search-image?query=clean%20white%20air%20conditioner%20filter%20being%20maintained%20close%20up%20view%20professional%20cleaning%20service%20fresh%20hygiene%20maintenance%20work%20detailed%20filter%20care%20residential%20system&width=600&height=400&seq=service-maintenance-001&orientation=landscape',
      link: '#'
    },
    {
      icon: 'ri-alarm-warning-fill',
      title: 'Assistenza Urgente 24h',
      description: 'Intervento rapido per emergenze disponibile 24 ore su 24, 7 giorni su 7',
      image: 'https://readdy.ai/api/search-image?query=white%20service%20van%20with%20air%20conditioning%20company%20branding%20parked%20at%20night%20emergency%20service%20vehicle%2024%20hour%20availability%20professional%20mobile%20unit%20nighttime%20urban%20setting&width=600&height=400&seq=service-emergency-001&orientation=landscape',
      link: '#'
    }
  ];

  return (
    <section id="services" className="py-24 bg-white relative overflow-hidden">
      {/* Subtle Pattern Background */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle, #00A3E0 1px, transparent 1px)', backgroundSize: '40px 40px' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-[#E6F4FF] text-[#1A2B4A] px-5 py-2 rounded-full text-sm font-semibold mb-4">
            I NOSTRI SERVIZI
          </div>
          <h2 className="text-[#1A2B4A] font-bold text-5xl mb-4">
            Soluzioni Complete per il Tuo Comfort
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden cursor-pointer"
              style={{ boxShadow: '0 4px 20px rgba(0, 163, 224, 0.1)' }}
            >
              <div className="p-8">
                <div className="flex items-start gap-6 mb-6">
                  <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-br from-[#0066CC] to-[#00A3E0] flex-shrink-0">
                    <i className={`${service.icon} text-white text-3xl`}></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-[#1A2B4A] font-bold text-2xl mb-3">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 text-base leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </div>

                {/* Image */}
                <div className="w-full h-48 rounded-2xl overflow-hidden mb-4">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>

                {/* Link */}
                <a
                  href={service.link}
                  className="inline-flex items-center gap-2 text-[#00A3E0] font-semibold text-sm hover:gap-3 transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  Scopri di più
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}